import { Variable } from '@mtna/pojo-consumer-ts';
import { VariableSummary } from '@mtna/variable-service-core-ts';

import { MeasureOptionType } from './measure-option.model';

export class MeasureSelection<V extends Variable | VariableSummary = Variable> {
  /**
   * @param measureType Type of measure
   * @param variable The selected variable for when the `MeasureOption` requires a variable selection
   */
  constructor(public measureType: MeasureOptionType, public variable?: V) {}
}
